export default "__VITE_ASSET__rdKqd1ZK__"